<template>
  <v-card class="pa-8 mt-4">
    <v-card-title class="mb-4 d-flex align-center">
      <v-btn
        class="me-4"
        color="primary"
        size="small"
        icon="fa-solid fa-circle-3"
      />
      <span>
        Imagens
      </span>
    </v-card-title>
    <v-row>
      <v-col
        v-for="(image, tag) in images"
        :key="tag"
        sm="4"
        lg="3"
      >
        <card-image-picker
          v-model="image.file"
          :label="image.label"
          :description="image.description"
          :dimensions="image.dimensions"
          @update:model-value="(file) => handleUpdate(file, image)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts" setup>
import CardImagePicker from '@/components/form/CardImagePicker.vue'
import Event from '@/types/Event'
import { onMounted, ref } from 'vue'

interface Props {
  event: Event
}

export interface ImageState {
  tag: ImageTags
  label: string
  description: string
  dimensions: { width: number, height: number }
  file: File | undefined
  url: string | undefined
  dirty: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [ImageState[]]
}>()

type ImageTags = 'card-thumb' | 'home-shield' | 'away-shield' | 'mapping-thumb'

const images = ref<ImageState[]>([
  {
    tag: 'card-thumb',
    label: 'Capa do Evento',
    description: 'Imagem que será exibida na listagem de eventos, vouchers e outros materiais de comunicação.',
    dimensions: { width: 1600, height: 1000 },
    file: undefined,
    url: undefined,
    dirty: false,
  },
  {
    tag: 'home-shield',
    label: 'Escudo do Mandante',
    description: 'Escudo usado para impressão monocromática de ingresso.',
    dimensions: { width: 150, height: 150 },
    file: undefined,
    url: undefined,
    dirty: false,
  },
  {
    tag: 'away-shield',
    label: 'Escudo do Visitante',
    description: 'Escudo usado para impressão monocromática de ingresso.',
    dimensions: { width: 150, height: 150 },
    file: undefined,
    url: undefined,
    dirty: false,
  },
  {
    tag: 'mapping-thumb',
    label: 'Mapa do Local',
    description: 'Mapa do local do evento, exibido no site de vendas. Recomendada a utilização de arte com setores.',
    dimensions: { width: 750, height: 750 },
    file: undefined,
    url: undefined,
    dirty: false,
  },
])

onMounted(() => {
  props.event.images?.forEach((image) => {
    const candidate = images.value.find(img => img.tag === image.tag)

    if (!candidate) return

    fetch(image.url)
      .then(response => response.blob())
      .then((blob) => {
        candidate.file = new File([ blob ], image.tag, { type: blob.type })
        candidate.url = image.url
      })
      .catch(() => {
        candidate.file = undefined
        candidate.url = undefined
      })
  })
})

function handleUpdate(file: File | undefined, image: ImageState) {
  image.file = file
  image.dirty = true

  emit('update:modelValue', images.value)
}

</script>
